// extracted by css-extract-rspack-plugin
export default {"drawer":"aobc5svIlpwRmaU0","header":"q3zrEebVhZQtytrK","overwrite":"oRczb4QlQx4WhzIS","overwriteLocator":"ES12LBmvAmgYfS3s","content":"LLUMgl1NrJUEQdEJ"};